import { useState, useEffect } from 'react'
import { GridColDef } from '@mui/x-data-grid';

import { adminAPI } from '../../../api';
import { StyledDataGrid, dataGridCellClassName, dataGridHeaderClassName, convertToDateTime, downloadObjects } from '../../../utils'

import BootstrapDateRangePicker from '../../../components/BootstrapDateRangePicker'


interface Props {
}

const PromptInterventionSimilarities : React.FC<Props> = ({}) => {

  const [promptInterventionSimilarities, setPromptInterventionSimilarities] = useState<any[]>()
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [timezoneOffset, setTimezoneOffset] = useState<number>()

  useEffect(() => {
    load()
  }, [startDate, endDate, timezoneOffset])


  const handleDateSelection = (startDate: string, endDate:string, timezoneOffset:number) => {
    setStartDate(startDate)
    setEndDate(endDate)
    setTimezoneOffset(timezoneOffset)
  }

  async function load(){
    if( startDate && endDate && timezoneOffset ){
      let {data: data} = await adminAPI.getPromptInterventionSimilarities(startDate, endDate, timezoneOffset)
      setPromptInterventionSimilarities(data['data']['data'])
    }
  }

  const columns: GridColDef[] = [
    { field: 'prompt', headerName: 'Prompt', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 250, flex:2},
    { field: 'intervention_prompt', headerName: 'Intervention Prompt', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 150, flex:2},
    { field: 'similarity', headerName: 'Similarity', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 150},
    { field: 'classified_dt', headerName: 'Classified On', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 120,
      renderCell: (params) => {
        return convertToDateTime(params.value)
      }
    }
  ]

  const handleDownload = () => {
    if( promptInterventionSimilarities && promptInterventionSimilarities.length > 0 ){
      downloadObjects('excel', promptInterventionSimilarities, 'prompt-intervention-similarities')
    }
  }

  return <div className="row">
    <div className="col-12">
      <h5>Prompt Intervention Similarities</h5>
      <div className="d-flex flex-row align-items-center justify-content-between mb-2 mt-1">
        <BootstrapDateRangePicker onDateSelect={handleDateSelection}/>
        <button className="btn download-messages-btn btn-sm btn-light" onClick={handleDownload}>
          Download
        </button>
      </div>
      <div className="card">
        <div className="card-body pt-5">
          <StyledDataGrid
            getRowId={(row) => row.id}
            rows={promptInterventionSimilarities}
            columns={columns}
            disableColumnMenu={false}
            getRowHeight={() => 'auto'}
            disableRowSelectionOnClick
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 50 },
              }
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
          />
        </div>
      </div>
    </div>
  </div>
}

export default PromptInterventionSimilarities;
